<div class="d-flex align-items-center justify-content-between mb-5">
    <div class="d-flex align-items-center">
        <button
            class="go-back small-action-btn bg-gray-500 text-white mr-3"
            (click)="goBack()"
            aria-label="Back to Contact us"
        >
            <img
                src="./assets/images/icons/common/chevron-back.svg"
                alt="Back"
                title="Back to Contact us"
            />
        </button>
        <h1 class="montserrat-light text-gray-500 text-capitalize mb-0">Privacy Policy</h1>
    </div>
</div>

<div class="legal-document">
    <div class="legal-subtitle">The Media Connector (TMC)</div>

    <h2>1. Introduction</h2>
    <p>
        The Media Connector (TMC) (“TMC,” “we,” “our,” “us”) respects your privacy and is
        committed to protecting your personal data. This Privacy Policy explains how we collect,
        use, disclose, and safeguard your information when you use our website, booking platform,
        and services relating to Digital Out-of-Home (DOOH) advertising including bookings and
        programmatic campaigns (collectively, the “Services”).
    </p>
    <p>By accessing our website or using our Services, you agree to this Privacy Policy.</p>

    <h2>2. Data We Collect</h2>
    <p>We may collect the following categories of personal and business data:</p>
    <ul>
        <li><b>Identity Data:</b> Name, company details, trade license number (if applicable).</li>
        <li><b>Contact Data:</b> Email, phone number, address.</li>
        <li><b>Account Data:</b> Username, password, account preferences.</li>
        <li><b>Transaction Data:</b> Payment details, billing address, booking history.</li>
        <li><b>Campaign Data:</b> Content you upload (ads, media, targeting preferences).</li>
        <li>
            <b>Technical Data:</b> IP address, device type, browser type, operating system, cookies,
            and analytics data.
        </li>
        <li>
            <b>Usage Data:</b> Interactions with our website and platform, campaign performance
            data.
        </li>
    </ul>

    <h2>3. How We Use Your Data</h2>
    <p>We use your personal data for the following purposes:</p>
    <ul>
        <li>
            <b>Service Delivery</b> to provide bookings, programmatic placements, and campaign
            management.
        </li>
        <li><b>Account Management</b> to create, secure, and maintain your user account.</li>
        <li><b>Payments</b> to process payments and invoices.</li>
        <li>
            <b>Compliance</b> to comply with UAE advertising, financial, and data protection
            regulations.
        </li>
        <li>
            <b>Analytics &amp; Improvements</b> to analyze campaign effectiveness and improve our
            platform.
        </li>
        <li>
            <b>Communications</b> to send service updates, confirmations, and marketing
            communications (if consented).
        </li>
    </ul>

    <h2>4. Legal Basis for Processing</h2>
    <p>Under UAE PDPL, we process your data based on:</p>
    <ul>
        <li>Your consent,</li>
        <li>Necessity for contract performance (executing your bookings),</li>
        <li>Legal obligations under UAE law, or</li>
        <li>
            TMC’s legitimate business interests (platform security, fraud prevention, analytics).
        </li>
    </ul>

    <h2>5. Data Sharing &amp; Transfers</h2>
    <p>We may share data with:</p>
    <ul>
        <li>
            <b>Advertising Partners</b> — media owners, DSPs, SSPs, and publishers for campaign
            execution.
        </li>
        <li><b>Payment Processors</b> for secure billing and transactions.</li>
        <li><b>Regulatory Authorities</b> where required by UAE law.</li>
        <li>
            <b>Third-Party Service Providers</b> — hosting, analytics, customer support.
        </li>
    </ul>
    <p>
        If data is transferred outside the UAE, TMC ensures compliance with PDPL cross-border
        transfer rules by requiring adequate safeguards or your explicit consent.
    </p>

    <h2>6. Cookies &amp; Tracking Technologies</h2>
    <p>We use cookies and similar technologies to:</p>
    <ul>
        <li>Improve website performance,</li>
        <li>Track campaign analytics,</li>
        <li>Store user preferences.</li>
    </ul>
    <p>
        Users may disable cookies through browser settings, but some Services may not function
        properly.
    </p>

    <h2>7. Data Retention</h2>
    <p>We retain your data only as long as necessary for:</p>
    <ul>
        <li>Service delivery,</li>
        <li>Compliance with UAE financial and regulatory obligations,</li>
        <li>Resolution of disputes, and</li>
        <li>Enforcement of agreements.</li>
    </ul>
    <p>When no longer needed, data will be securely deleted or anonymized.</p>

    <h2>8. Your Rights</h2>
    <p>Under UAE PDPL, you have the right to:</p>
    <ul>
        <li>Access your personal data,</li>
        <li>Request correction of inaccurate data,</li>
        <li>Request deletion of your data,</li>
        <li>Withdraw consent at any time,</li>
        <li>Object to processing where applicable,</li>
        <li>Request data portability in a structured, machine-readable format.</li>
    </ul>
    <p>
        Requests may be made to
        <a href="mailto:info@themediaconnector.com">info@themediaconnector.com</a>. We will respond
        in accordance with UAE PDPL timelines.
    </p>

    <h2>9. Data Security</h2>
    <p>
        We implement appropriate technical and organizational measures to protect your personal data
        from unauthorized access, loss, misuse, or disclosure. However, no online system is
        completely secure, and TMC cannot guarantee absolute security.
    </p>

    <h2>10. Children’s Privacy</h2>
    <p>
        Our Services are intended for business users. We do not knowingly collect personal data from
        children under 18 years in the UAE. If you believe a child has provided data to us, please
        contact us immediately.
    </p>

    <h2>11. Updates to This Policy</h2>
    <p>
        We may update this Privacy Policy from time to time. Changes will be posted on our website
        with a revised “Effective Date.” Continued use of our Services constitutes acceptance of
        the updated Policy.
    </p>

    <h2>12. Contact Us</h2>
    <p>For privacy-related inquiries, please contact:</p>
    <div class="legal-contact">
        <p>The Media Connector (TMC)</p>
        <p>Email: <a href="mailto:info@themediaconnector.com">info@themediaconnector.com</a></p>
        <p>Phone: <a href="tel:+971504959458">+971 50 49 59 458</a></p>
        <p>Registered Address: United Arab Emirates, Dubai, Aurora Tower, Office 815</p>
    </div>
</div>
